import React from 'react'
import { IconButton, useModal } from '@nominex/dex-uikit'
import SettingsModal from './SettingsModal'

const GlobalSettings = ({ IconComponent }) => {
  const [onPresentSettingsModal] = useModal(<SettingsModal />)

  return (
    <div className="flex">
      <IconButton onClick={onPresentSettingsModal} variant="text" scale="sm" id="open-settings-dialog-button">
        <IconComponent height={20} width={20} color="textSubtle" />
      </IconButton>
    </div>
  )
}

export default GlobalSettings
